import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TransactionAuthorizationComponent } from '@zero/shared/ui-web-components';
import { AuthPayloadRetireDevice, AuthorizationData, EnrolledDevice, TransactionAuthorizationResult } from '@zero/shared/util-models';

@Component({
  selector: 'self-service-apptan-retirement',
  templateUrl: './app-tan-retirement.component.html',
  standalone: true,
  imports: [TransactionAuthorizationComponent, TranslocoPipe],
})
export class AppTanRetirementComponent implements OnInit {
  public dataToAuthorize?: AuthorizationData<AuthPayloadRetireDevice>;
  @Input() public deviceToRetire?: EnrolledDevice;
  @Output() public retirementCanceledOrFinished = new EventEmitter<void>();

  public ngOnInit(): void {
    this.dataToAuthorize = new AuthorizationData<AuthPayloadRetireDevice>(
      new AuthPayloadRetireDevice(this.deviceToRetire?.customerDeviceName, this.deviceToRetire?.serial),
    );
  }

  public authorizedTransactionResult(result: TransactionAuthorizationResult): void {
    if (result.success) {
      this.dataToAuthorize = undefined;
    } else if (result.reason === 'CanceledByUser') {
      this.dataToAuthorize = undefined;
    } else {
      return;
    }

    this.retirementCanceledOrFinished.emit();
  }
}
